import { transactionService } from '@/common/api.service'

const initialStates = {
    status: 'loading',
    statistics: {
        total_profit: 0,
        transactions_sum: 0,
        succeeded_trans_count: 0,
        failed_trans_count: 0,
    },
    excelRequests: {data: []},
    phone_numbers: [],
    count_of_failed_transaction: null,
    period_of_failed_transaction: null,
    non_success_phone_numbers: [],
    count_of_non_success_transaction: null,
    period_of_non_success_transaction: null,
}

const mutations = {
    loading(state) {
        state.status = 'loading'
    },
    success(state, statistics) {
        state.status    = 'success'
        state.statistics = statistics
    },
    fail(state) {
        state.status    = 'fail'
        state.statistics = []
    },
    setExcelRequests(state , response) {
        state.excelRequests = response.data
    },
    setTransactionNotificationSetting(state, response) {
        state.phone_numbers = response.data.users
        state.count_of_failed_transaction = response.data.count_of_failed_transaction
        state.period_of_failed_transaction = response.data.period_of_failed_transaction
    },
    setCountOfFailedTransaction(state, data) {
        state.count_of_failed_transaction = data
    },
    setPeriodOfFailedTransaction(state, data) {
        state.period_of_failed_transaction = data
    },
    setNonSuccessTransactionNotificationSetting(state, response) {
        state.non_success_phone_numbers = response.data.data.users
        state.count_of_non_success_transaction = response.data.data.count_of_non_success_transaction
        state.period_of_non_success_transaction = response.data.data.period_of_non_success_transaction
    },
    setCountOfNonSuccessTransaction(state, data) {
        state.count_of_non_success_transaction = data
    },
    setPeriodOfNonSuccessTransaction(state, data) {
        state.period_of_non_success_transaction = data
    },
}

const getters = {
    status: state => state.status,
    statistics: state => state.statistics,
    excelRequests: state => state.excelRequests,
    phone_numbers: state => state.phone_numbers,
    count_of_failed_transaction: state => state.count_of_failed_transaction,
    period_of_failed_transaction: state => state.period_of_failed_transaction,
    non_success_phone_numbers: state => state.non_success_phone_numbers,
    count_of_non_success_transaction: state => state.count_of_non_success_transaction,
    period_of_non_success_transaction: state => state.period_of_non_success_transaction,
}

const actions = {
    fetchCoreStatistics({commit}, query) {
        commit('loading')
        return transactionService.fetchCoreStatistics(query)
            .then(response => {
                commit('success', response.data.data)
                //console.log(response)
            })
    },
    fetchAdminCoreStatistics({commit}, query) {
        commit('loading')
        return transactionService.fetchAdminCoreStatistics(query)
            .then(response => {
                commit('success', response.data.data)
                //console.log(response)
            })
    },
    fetchStarshopStatistics({commit}, query) {
        commit('loading')
        return transactionService.fetchStarshopStatistics(query)
            .then(response => {
                commit('success', response.data.data)
                //console.log(response)
            })
    },
    fetchAdminStarshopStatistics({commit}, query) {
        commit('loading')
        return transactionService.fetchAdminStarshopStatistics(query)
            .then(response => {
                commit('success', response.data.data)
                //console.log(response)
            })
    },
    fetchCoreExcelRequests({commit} , query){
        commit('loading')
        return transactionService.fetchCoreExcelRequests(query)
            .then(response => {
                commit('setExcelRequests' , response.data)
            })
    },
    fetchStarshopExcelRequests({commit} , query){
        commit('loading')
        return transactionService.fetchStarshopExcelRequests(query)
            .then(response => {
                commit('setExcelRequests' , response.data)
            })
    },
    fetchTransactionNotificationSetting({commit}) {
        commit('loading')
        return transactionService.fetchTransactionNotificationSetting()
            .then(response => {
                commit('setTransactionNotificationSetting', response.data)
            })
    },
    fetchNonSuccessTransactionNotificationSetting({commit}) {
        return transactionService.fetchNonSuccessTransactionNotificationSetting()
            .then(response => {
                commit('setNonSuccessTransactionNotificationSetting', response.data)
            })
    },
}

export default {
    namespaced: true,
    state: initialStates,
    mutations: mutations,
    getters: getters,
    actions: actions,
}